import { createStyles, rem } from '@mantine/core';
import styled from '@emotion/styled';

export const FoodItemsContainerScrollArea = styled.div(({}) => ({
  maxHeight: '100svh',
  paddingBottom: 5,
  overflowY: 'auto',
  height: 'calc(100svh - 400px)',
  position: 'relative',

  [`@media (max-width: 768px)`]: {
    height: 'calc(100svh - 360px)',
  },

  '&::-webkit-scrollbar': {
    width: 2,
  },
  '&:hover': {
    '&::-webkit-scrollbar-thumb': {
      background: '#888',
      borderRadius: 10,
    },
  },
  // '.disabled': {
  //   '::before': {
  //     content: "''",
  //     width: '100%',
  //     height: '100%',
  //     position: 'absolute',
  //     top: 0,
  //     left: 0,
  //     background: '#ccc',
  //     zIndex: '10',
  //   },
  // },
}));

export const useFoodItemsContainerStyles = createStyles((theme) => ({
  goToCartButton: {
    width: 270,
    backgroundColor: theme.colors.red[6],
    color: 'white',
    fontWeight: 600,
    padding: `${rem(14)} ${rem(16)}`,
    borderRadius: 12,
    boxShadow: '0px 5px 8px -4px rgba(0,0,0,0.1)',

    [theme.fn.smallerThan('sm')]: {
      width: 240,
      padding: `${rem(12)} ${rem(12)}`,
      fontSize: 14,
    },
  },

  gridCol: {
    padding: 8,

    [theme.fn.smallerThan('sm')]: {
      paddingInline: 0,
      paddingTop: 8,
      paddingBottom: 8,
    },
  },
}));

export const useCategoryContainerStyles = createStyles((theme) => ({
  categoryText: {
    color: theme.colors.red[6],
    cursor: 'pointer',
    fontWeight: 600,
    minWidth: 'fit-content',
    // lineHeight: 1,
    '&:not(:last-child)': {
      marginRight: '1.25rem',
    },
  },

  selectedCategory: {
    position: 'relative',
    backgroundImage: 'linear-gradient(to right, #D61D4F, #D61D4F)',
    backgroundPosition: 'bottom left',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 2px',
    cursor: 'pointer',
  },

  unSelectedCategory: {
    textDecoration: 'none',
  },
}));

export const useCategoryContainerScrollAreaStyles = createStyles((theme) => ({
  root: {
    height: '100%',
    width: '100%',
  },
  viewport: {
    display: 'flex',
    alignItems: 'center',
  },
}));

export const useCategoriesWithSearchStyles = createStyles((theme) => ({
  gridCol: {
    padding: 0,
    margin: 0,
    WebkitFlexShrink: 0,
    flexShrink: 0,
    WebkitFlexGrow: 0,
    flexGrow: 0,
    ':-ms-flex-negative': 0,
    ':-ms-flex-positive': 0,
    ':-webkit-box-flex': 0,
  },

  searchGridCol: {
    display: 'flex',
    justifyContent: 'center',

    WebkitFlexBasis: `${(1 / 12) * 100}%`,
    flexBasis: `${(1 / 12) * 100}%`,
    maxWidth: `${(1 / 12) * 100}%`,
    ':-ms-flex-preferred-size': `${(1 / 12) * 100}%`,

    [theme.fn.smallerThan(576)]: {
      WebkitFlexBasis: `${(2 / 12) * 100}%`,
      flexBasis: `${(2 / 12) * 100}%`,
      maxWidth: `${(2 / 12) * 100}%`,
      ':-ms-flex-preferred-size': `${(2 / 12) * 100}%`,
    },
  },
  sliderGridCol: {
    WebkitFlexBasis: `${(11 / 12) * 100}%`,
    flexBasis: `${(11 / 12) * 100}%`,
    maxWidth: `${(11 / 12) * 100}%`,
    ':-ms-flex-preferred-size': `${(11 / 12) * 100}%`,
    height: 'auto',

    [theme.fn.smallerThan(576)]: {
      WebkitFlexBasis: `${(10 / 12) * 100}%`,
      flexBasis: `${(10 / 12) * 100}%`,
      maxWidth: `${(10 / 12) * 100}%`,
      ':-ms-flex-preferred-size': `${(10 / 12) * 100}%`,
    },
  },
}));

export const useInfoHeaderStyles = createStyles((theme) => ({
  container: {
    position: 'relative',
    width: '100%',
  },

  restaurantCardBox: {
    position: 'absolute',
    width: '80%',
    top: '30%',
    left: '50%',
    transform: 'translateX(-50%)',
    borderRadius: 16,
    padding: 16,
    background: 'rgba(255, 255, 255, 0.75)',
    backdropFilter: 'blur(9px)',
    boxShadow: '0px 4px 8px 0px rgba(0,0,0,0.1)',

    [`@media (max-width: 768px)`]: {
      top: '10%',
    },

    [theme.fn.smallerThan('sm')]: {
      width: '90%',
    },
  },
  rating: {
    cursor: 'pointer',
  },
}));

export const useFoodItemsCardStyles = createStyles((theme) => ({
  containerEnable: {
    padding: 8,
    boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.15)',
    border: '0.0625rem solid #dee2e6',
    cursor: 'pointer',
    borderRadius: 20,
    background: 'white',
  },
  containerDisable: {
    padding: 8,
    boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.15)',
    border: '0.0625rem solid #dee2e6',
    cursor: 'not-allowed',
    borderRadius: 20,
    background: theme.colors.gray[3],
  },

  genericGridCol: {
    padding: 0,
    margin: 0,
    WebkitFlexShrink: 0,
    flexShrink: 0,
    WebkitFlexGrow: 0,
    flexGrow: 0,
    ':-ms-flex-negative': 0,
    ':-ms-flex-positive': 0,
    ':-webkit-box-flex': 0,
  },

  firstGridCol: {
    WebkitFlexBasis: `${(3 / 12) * 100}%`,
    flexBasis: `${(3 / 12) * 100}%`,
    maxWidth: `${(3 / 12) * 100}%`,
    ':-ms-flex-preferred-size': `${(3 / 12) * 100}%`,
  },

  secondGridCol: {
    WebkitFlexBasis: `${(6.5 / 12) * 100}%`,
    flexBasis: `${(6.5 / 12) * 100}%`,
    maxWidth: `${(6.5 / 12) * 100}%`,
    ':-ms-flex-preferred-size': `${(6.5 / 12) * 100}%`,
  },

  thirdGridCol: {
    WebkitFlexBasis: `${(2.5 / 12) * 100}%`,
    flexBasis: `${(2.5 / 12) * 100}%`,
    maxWidth: `${(2.5 / 12) * 100}%`,
    ':-ms-flex-preferred-size': `${(2.5 / 12) * 100}%`,
  },
}));
